import ClosableModal from "@components/closable-modal/closable-modal";
import ModalPadding from "@components/closable-modal/modal-padding";
import PlusIcon from "@components/icons/plus-icon";
import ModalTitle from "@components/modal-title";
import NotAuthorized from "@features/auth/not-authorized";
import type { ProductType } from "@type/global";
import { useAuth } from "@provider/context-auth";
import { Text, useSx, View } from "dripsy";
import { Pressable } from "react-native";
import * as React from "react";
import { useState } from "react";
import FavouriteNameModal from "./favourite-name-modal";
import ClosableModalScrollView from "../../../components/closable-modal/closable-modal-scrollview";
import FavouriteList from "@features/favourite/favourite-modal/favourite-list";

function FavouriteModal({ product, onClose }: { product: ProductType; onClose: () => void }) {
  const [newWishlistModalVisible, setNewWishlistModalVisible] = useState(false);
  const { isAuthenticated } = useAuth();
  const sx = useSx();

  return (
    <ClosableModal isVisible onRequestClose={onClose}>
      <ModalTitle
        title="Favorietenlijst"
        right={
          isAuthenticated ? (
            <Pressable
              onPress={() => setNewWishlistModalVisible(true)}
              style={sx({
                flexDirection: "row",
                alignItems: "center",
              })}
            >
              <PlusIcon size={24} color="$primary" />
              <Text sx={{ fontSize: 16, fontWeight: "600", color: "$primary", marginLeft: "$1" }}>Nieuw</Text>
            </Pressable>
          ) : undefined
        }
      />
      <ClosableModalScrollView style={{ flex: 1 }}>
        <ModalPadding>
          {isAuthenticated ? (
            <FavouriteList product={product} />
          ) : (
            <View sx={{ px: "$2", pt: "$2" }}>
              <NotAuthorized
                onPress={() => {
                  setNewWishlistModalVisible(false);
                  onClose();
                }}
              />
            </View>
          )}
        </ModalPadding>
      </ClosableModalScrollView>
      {newWishlistModalVisible ? (
        <FavouriteNameModal
          modalVisible={newWishlistModalVisible}
          onClose={() => setNewWishlistModalVisible(false)}
          product={product}
        />
      ) : null}
    </ClosableModal>
  );
}
export default FavouriteModal;
